import VueRecaptcha from "vue-recaptcha";
export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      timerEnabled: false,
      timerCount: 120,
      recaptchaResponse: "",
      verify_dialog: false,
      phone: null,
      phone_sample: null,
      codeVerified: false,
    }
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },
    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  created() {
  },
  computed: {
    count_seconds(){
      let secconds = this.timerCount % 60
      if (secconds < 10) {
        secconds = '0' + secconds
      }
      return secconds
    },
    count_minute(){
      let secconds = this.timerCount % 60
      let minutes = (this.timerCount - secconds) / 60
      if ( minutes < 10) {
        minutes = '0' + minutes
      }
      return minutes
    },
    UserInvitationStatuses() {
      return [{
          text: "در انتظار بررسی",
          value: "p",
        },
        {
          text: "پذیرفته شده",
          value: "a",
        },
        {
          text: "رد شده",
          value: "r",
        }
      ]
    },
    passwordRules() {
      return [
        (value) =>
        /(?=.{8,})/.test(value) ||
        "طول کلمه عبور باید بیشتر از 8 کاراکتر باشد",
        (value) => /(?=.*[0-9])/.test(value) || "حداقل از یک عدد استفاده کنید",
        (value) =>
        /(?=.*[!@#$%^&*])/.test(value) ||
        "حداقل از یکی از کاراکتر های ! @ # $ % ^ & * استفاده کنید",
        (value) => /[A-Z]/.test(value) || "حداقل از یک حرف بزرگ استفاده کنید",
      ];
    },
  },
  methods: {
    sendVerificationCode(data, callback = null) {
      this.codeVerified = false
      this.request({
        url: this.endpoint("users/sendVerificationCode"),
        method: "post",
        data: data,
        token: false,
        success: data => {
          this.$refs.recaptcha && this.$refs.recaptcha.reset();
          callback && callback(data)
          this.verify_dialog = true
          this.phone_sample = data.phone_sample
          this.notify('کد تایید ارسال شد', 'success')
          this.timerCount = 120
          this.timerEnabled = true

        },
        error: (error) => {
          this.$refs.recaptcha && this.$refs.recaptcha.reset();
          this.handleError(error, {});
        }
      });
    },
    checkVerificationCode(code) {
      this.request({
        url: this.endpoint("users/checkVerificationCode"),
        method: "post",
        data: {
          'username': this.username || this.user.username,
          'verificationCode': code
        },
        token: false,
        success: data => {
          this.notify('کد تایید اعتبارسنجی شد', 'success')
          this.verify_dialog = false
          this.codeVerified = true
        },
        error: (error) => {
          this.$refs.recaptcha && this.$refs.recaptcha.reset();
          this.handleError(error, {});
        }
      });
    },
  }

}